/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N5Inputs */

const en_to_typescript_ref_n5 = /** @type {(inputs: To_Typescript_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a nullable string or number. Widen this by hand once you know the real type.`)
};

const ko_to_typescript_ref_n5 = /** @type {(inputs: To_Typescript_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nullable 문자열이나 숫자가 아닙니다. 실제 타입을 알게 되면 직접 넓히세요.`)
};

const ja_to_typescript_ref_n5 = /** @type {(inputs: To_Typescript_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nullable な文字列や数値ではありません。実際の型が分かったら手で広げてください。`)
};

/**
* | output |
* | --- |
* | "Not a nullable string or number. Widen this by hand once you know the real type." |
*
* @param {To_Typescript_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n5 = /** @type {((inputs?: To_Typescript_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n5(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n5(inputs)
	return ja_to_typescript_ref_n5(inputs)
});